import React from "react";

export interface TableViabilidadeProps {
  viabilityData: {
    measuringPointName: string;
    thsDiscountActual: string;
    recommendedChange: string;
    monthCount: string;
    averageEconomy: number;
    percentEconomy: number;
    "AZUL CONVENCIONAL": number;
    "AZUL I5": number;
    "AZUL I1": number;
    "VERDE CONVENCIONAL": number;
    "VERDE I5": number;
    "VERDE I1": number;
  };
}

export function TableViabilidade({
  resumeViabilities,
}: {
  resumeViabilities: TableViabilidadeProps[];
}) {
  const fmtBRL = (v: number) =>
    v?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

  const fmtInt = (v: number) => v?.toLocaleString("pt-BR");

  return (
    <>
      <div className="d-md-none" style={{ maxHeight: 320, overflowY: "auto" }}>
        {Array.isArray(resumeViabilities)
          ? resumeViabilities.map((item, idx) => (
              <div className="card mb-2" key={idx}>
                <div className="card-body">
                  <div className="d-flex justify-content-between text-center">
                    <strong>Unidade</strong>
                    <span>
                      {item.viabilityData.measuringPointName
                        .split(" - ")
                        .slice(1)
                        .join(" - ")}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between text-center">
                    <strong>Tipo atual</strong>
                    <span>{item.viabilityData.thsDiscountActual}</span>
                  </div>
                  <div className="d-flex justify-content-between text-center">
                    <strong>Tipo ideal</strong>
                    <span className="text-truncate">
                      {item.viabilityData.recommendedChange}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between text-center">
                    <strong>Economia mensal</strong>
                    <span>
                      {fmtBRL(item.viabilityData.averageEconomy)} (
                      {item.viabilityData.percentEconomy}%)
                    </span>
                  </div>

                  <hr className="my-2" />

                  <div className="d-flex justify-content-between text-center">
                    <span>AZUL CONV</span>
                    <strong>
                      {fmtInt(item.viabilityData["AZUL CONVENCIONAL"])}
                    </strong>
                  </div>

                  <div className="d-flex justify-content-between text-center">
                    <span>VERDE CONV</span>
                    <strong>
                      {fmtInt(item.viabilityData["VERDE CONVENCIONAL"])}
                    </strong>
                  </div>

                  <div className="d-flex justify-content-between text-center">
                    <span>AZUL I5</span>
                    <strong>{fmtInt(item.viabilityData["AZUL I5"])}</strong>
                  </div>

                  <div className="d-flex justify-content-between text-center">
                    <span>VERDE I5</span>
                    <strong>{fmtInt(item.viabilityData["VERDE I5"])}</strong>
                  </div>

                  <div className="d-flex justify-content-between text-center">
                    <span>AZUL I1</span>
                    <strong>{fmtInt(item.viabilityData["AZUL I1"])}</strong>
                  </div>

                  <div className="d-flex justify-content-between text-center">
                    <span>VERDE I1</span>
                    <strong>{fmtInt(item.viabilityData["VERDE I1"])}</strong>
                  </div>
                </div>
              </div>
            ))
          : null}
      </div>

      <div className="d-none d-md-block" style={{ overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "16px",
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: "#f5f5f5",
                borderBottom: "2px solid #0072ce",
              }}
            >
              <th
                style={{
                  padding: "12px",
                  textAlign: "left",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                Unidade
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "left",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                Tipo atual
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                Tipo ideal
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                Economia mensal (R$ / %)
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                AZUL CONV
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                VERDE CONV
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                AZUL I5
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                VERDE I5
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                AZUL I1
              </th>
              <th
                style={{
                  padding: "12px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                VERDE I1
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(resumeViabilities)
              ? resumeViabilities.map((item, idx) => (
                  <tr
                    key={idx}
                    style={{
                      borderBottom: "1px solid #e0e0e0",
                      backgroundColor: idx % 2 === 0 ? "#ffffff" : "#f9f9f9",
                    }}
                  >
                    <td
                      style={{
                        padding: "12px",
                        fontSize: "13px",
                      }}
                    >
                      {item.viabilityData.measuringPointName
                        .split(" - ")
                        .slice(1)
                        .join(" - ")}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        fontSize: "13px",
                      }}
                    >
                      {item.viabilityData.thsDiscountActual}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                    >
                      {item.viabilityData.recommendedChange}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        textAlign: "center",
                        fontSize: "13px",
                        fontWeight: "bold",
                        color: "#28a745",
                      }}
                    >
                      {fmtBRL(item.viabilityData.averageEconomy)} (
                      {item.viabilityData.percentEconomy}%)
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                    >
                      {fmtInt(item.viabilityData["AZUL CONVENCIONAL"])}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                    >
                      {fmtInt(item.viabilityData["VERDE CONVENCIONAL"])}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                    >
                      {fmtInt(item.viabilityData["AZUL I5"])}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                    >
                      {fmtInt(item.viabilityData["VERDE I5"])}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                    >
                      {fmtInt(item.viabilityData["AZUL I1"])}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        textAlign: "center",
                        fontSize: "13px",
                      }}
                    >
                      {fmtInt(item.viabilityData["VERDE I1"])}
                    </td>
                  </tr>
                ))
              : null}
            {Array.isArray(resumeViabilities) && resumeViabilities.length > 0 && (
              <tr
                style={{
                  borderTop: "2px solid #0072ce",
                  backgroundColor: "#e8f4fd",
                }}
              >
                <td
                  colSpan={3}
                  style={{
                    padding: "12px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    textAlign: "right",
                  }}
                >
                  Total de economia média mensal:
                </td>
                <td
                  style={{
                    padding: "12px",
                    textAlign: "center",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "#28a745",
                  }}
                >
                  {fmtBRL(
                    resumeViabilities.reduce(
                      (acc, item) =>
                        acc + (item.viabilityData.averageEconomy || 0),
                      0
                    )
                  )}
                </td>
                <td colSpan={6} />
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
